// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"4890c63bd92e392a","3877":"fe336940f98fdfab","6272":"aa4472f7082b94cd","7584":"d9652db206d50763","7891":"98dd3c6dfa818c92","9755":"d99bef0306b4f977"}[chunkId] + ".css";
};